// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import  BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueCircleSlider from 'vue-circle-slider'
import VueGtag from "vue-gtag";
import './assets/css/style.css';

Vue.use(VueCircleSlider)
// globally (in your main .js file)
Vue.component('v-icon', Icon)
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueGtag, {
  config: { id: "UA-90740854-1" },
  pageTrackerTemplate(to) {
    return {
      page_path : to.fullPath,
      page_title: 'Plateforme Résultats - '+to.name
    }
  }
}, router);

Vue.config.productionTip = false

Vue.prototype.$admin = {logged : false};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
